import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { clearCandidateSearchFilter } from "@redux/actionCreators";
import { getCurrentUserRole } from "@redux/actionCreators/siteList";

import constants from "@constants/constants";
import Auth from "config/auth";
import { getTabsForRole } from "../../router/app-route-config";

import "./styles.scss";

const authData = Auth.getSessionDetails();
const { currentUserRole } = authData;

const {
  PAGE_ROUTES: { CANDIDATE_LISTING_ROUTE }
} = constants;

const CANDIDATE_LISTING_FALLBACK = {
  key: "CANDIDATE_LISTING",
  route: CANDIDATE_LISTING_ROUTE
};

const SubHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { pathname = "" } = location || "";

  const [selectedTabKey, setSelectedTabKey] = useState(null);
  const [currentRole, setCurrentRole] = useState();

  const getActiveRole = () => {
    const uniqueSessionRole = sessionStorage.getItem("uniqueTabRole");
    const userRole = localStorage.getItem("role");

    if (!userRole || userRole === "null") {
      localStorage.setItem("role", currentUserRole);
      sessionStorage.setItem("role", currentUserRole);
    }

    return uniqueSessionRole || userRole || null;
  };

  const activeRole = getActiveRole();
  const tabs = getTabsForRole(activeRole);

  const handleTabChange = ({ key }) => {
    if (key !== selectedTabKey) {
      dispatch(clearCandidateSearchFilter());
    }

    const selectedTab = tabs.find(tab => tab.key === key);
    if (selectedTab) {
      setSelectedTabKey(selectedTab.key);
      navigate(selectedTab.route);
    } else {
      const fallback =
        tabs.find(tab => tab.key === CANDIDATE_LISTING_FALLBACK.key) ||
        tabs[0] ||
        CANDIDATE_LISTING_FALLBACK;
      setSelectedTabKey(fallback.key);
      navigate(fallback.route);
    }
  };

  useEffect(() => {
    const role = localStorage.getItem("role") || currentUserRole;
    setCurrentRole(role);
    dispatch(getCurrentUserRole(role));
  }, [currentRole]);

  useEffect(() => {
    const selectedTab = tabs.find(tab => tab.route === pathname);

    if (!selectedTab) return;

    if (!selectedTabKey || selectedTabKey !== selectedTab.key) {
      setSelectedTabKey(selectedTab.key);
    }
  }, [pathname, activeRole]);

  return (
    <div className="sub-header">
      <div className="sub-header-menu-tab">
        <Menu
          mode="horizontal"
          onClick={handleTabChange}
          items={tabs}
          selectedKeys={[selectedTabKey]}
        />
      </div>
    </div>
  );
};

export default React.memo(SubHeader);
